'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  components: {
    svg: 'svg',
    circle: 'circle',
    ellipse: 'ellipse',
    g: 'g',
    linearGradient: 'linearGradient',
    radialGradient: 'radialGradient',
    line: 'line',
    pattern: 'pattern',
    path: 'path',
    polygon: 'polygon',
    polyline: 'polyline',
    rect: 'rect',
    symbol: 'symbol',
    text: 'text',
    use: 'use',
    defs: 'defs',
    stop: 'stop'
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/@potion/util/lib/defaultProps.js
// module id = 221
// module chunks = 168707334958949